module.exports = __webpack_public_path__ + "static/karussel5-a86e401909f4819e85ca96b067d783bb.jpg";